exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/base/base.component.css
// module id = 158
// module chunks = 0